<template>
  <div>
    <div v-show="!isReady" class="loading">
      <van-loading size="72"/>
    </div>
    <div v-show="isReady && isLogin">
      正在进入...
      <!--      <div>授权登录</div>-->
      <!--      <br>-->
      <!--      <br>-->
      <!--      <van-button type="info" @click="getCode">同意</van-button>-->
      <!--      <van-button type="default" @click="refuse">拒绝</van-button>-->
    </div>
    <div v-show="isReady && !isLogin">
      请先登录
    </div>
  </div>
</template>

<script>
import {noticeAppSetDeviceData} from '../api/KdAppNative'
import {tempAccessCode} from '../api/client.api'

export default {
  name: 'index',
  data () {
    return {
      isReady: false,
      isLogin: false,
      data: {
        loginToken: '',
        clientID: '',
        groupOpenID: '',
        redirectURL: ''
      }
    }
  },
  mounted () {
    this.data.clientID = this.$route.query.appId
    this.data.groupOpenID = this.$route.query.groupOpenId
    this.data.redirectURL = this.$route.query.redirectUrl
    setTimeout(() => {
      // try {
      //   // 通知App设置用户token
      //   noticeAppSetUserToken()
      // } catch (e) {
      //   console.error('NoticeAppSetUserToken Error', e)
      // }
      try {
        // 通知App设置设备信息
        noticeAppSetDeviceData()
      } catch (e) {
        console.error('NoticeAppSetDeviceData Error', e)
      }
    }, 200)
  },
  methods: {
    getCode () {
      this.data.loginToken = this.$store.getters.header.device.token
      console.log('this.data是什么', this.data)
      const o = this
      tempAccessCode(this.data).then((res) => {
        if (res.code === 200) {
          window.location.href = o.data.redirectURL + '?groupOpentId=' + this.data.groupOpenID + '&code=' + res.data.code
        } else {
          o.$toast.fail(res.message)
        }
      })
    },
    refuse () {
      window.location.href = this.data.redirectURL
    }
  },
  computed: {
    header () {
      return this.$store.getters.header
    },
    token () {
      return this.$store.getters.header.device.token
    }
  },
  watch: {
    'header': {
      handler (val, oval) {
        this.isReady = true
        setTimeout(() => {
          this.getCode()
        }, 200)
      },
      deep: true
      // immediate: true
    },
    'token': {
      handler (val, oval) {
        if (val !== '') {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      },
      deep: true
      // immediate: true
    }
  }
}
</script>

<style scoped>
  .loading {
    text-align: center;
    position: absolute;
    top: calc(50% - 36px);
    left: calc(50% - 36px);
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue